import React, { useState, useContext } from 'react';
import { Search } from 'semantic-ui-react';
import LocaleContext from 'context/locale-context';
import time from 'lib/times';
import localeMessages from 'components/create/StyledDateTimePicker/locale.js';

import styles from './StatefulSearch.css';

export const StatefulSearch = ({
  date,
  onResultSelect,
  input,
  formatMessage,
  noResultsMessage = undefined,
  onCalculateValueWhenFocused,
  showAllTimes = false,
  onlyShowTimesAfterGivenTime = '',
  timesToSkip = [],
}) => {
  const [searchElement, setSearchElement] = useState(null);
  const [times, setTimes] = useState();
  const { locale } = useContext(LocaleContext);

  function getResults(value) {
    return timesToSkip.length > 0
      ? findResultsFromValue(value).filter(result => !timesToSkip.includes(result.key))
      : findResultsFromValue(value);
  }

  function onFocus({ target, value = '' }) {
    setSearchElement(target);
    setTimes(getResults(value));
  }

  function onSearchChange(value = '') {
    setTimes(getResults(value));
  }

  function onResultSelection(result) {
    onResultSelect(result);
    searchElement.blur();
    setSearchElement(null);
  }

  // private
  function findResultsFromValue(value) {
    return time.getResults(value.toString(), locale, {
      isToday: !showAllTimes && time.isDateSelectedToday(date),
      onlyShowTimesAfterGivenTime,
    });
  }

  return (
    <Search
      className={styles.rightInitial}
      selectFirstResult
      open={!!searchElement}
      results={times}
      noResultsMessage={noResultsMessage || formatMessage(localeMessages.errorInvalidTime)}
      onResultSelect={(_, { result }) => onResultSelection(result)}
      input={input}
      value={onCalculateValueWhenFocused(!!searchElement)}
      onBlur={() => setSearchElement(null)}
      onFocus={({ target }, { value }) => onFocus({ target, value })}
      onSearchChange={(_, { value }) => onSearchChange(value)}
    />
  );
};
